import { initModule } from './init-module';

initModule();

export { ContactInfoLibraryRoutes } from './contactInfo-library.routes';

export { contactInfoLibrary } from './contactInfo-library.config';

export { ContactInfoLibraryComponent } from './components/contact-information/contactInfo-library.component';
